import React, {Component} from 'react';
import sectionChooser from "./sections/sectionChooser";
import {Loading} from "../../../components/Loading";

export default class PostSections extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    getSections() {
        const sections = this.props.sections;
        return sections.map(function (section) {
            return sectionChooser(section);
        });
    }

    componentDidUpdate() {
        if (this.props.sections.length > 0) {
            const script = document.createElement("script");
            script.src = process.env.PUBLIC_URL+"/js/core.js";
            script.async = true;
            document.body.appendChild(script);
        }
        if (this.state.loading) {
            this.setState({loading:false});
        }
    }

    render() {
        return (
            <section className="py-5 px-7">
                <div className="container p-0">

                    <Loading visible={this.state.loading}/>

                    <div className="row no-gutters">
                        <div className="offset-md-2 col-md-8 ">
                            {this.getSections()}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/visitors/components/post/PostSections.js